import {Component, OnDestroy, OnInit} from '@angular/core';
import {AngularFireAuth} from 'angularfire2/auth';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
    authStateSubscription: Subscription;

    currentLang = 'en';
    langEntries = [];

    constructor(public afAuth: AngularFireAuth, public router: Router, public translate: TranslateService) {
        this.authStateSubscription = this.afAuth.authState.subscribe(auth => {
            if (!auth) {
                router.navigate(['/login']);
            }
        });
    }

    ngOnInit() {
        this.langEntries = [
            {key: 'En', value: 'ENGLISH'},
            {key: 'Es', value: 'SPANISH'}
        ];

        if (!localStorage.getItem('lang')) {
            this.setLang(this.langEntries[0].key);
        }
        this.currentLang = localStorage.getItem('lang');
        this.setLang(this.currentLang);
    }

    setLang(lang) {
        this.currentLang = lang;
        localStorage.setItem('lang', lang);
        moment.locale(lang.toLowerCase());
        this.translate.use(lang.toLowerCase());
    }

    logout() {
        this.afAuth.auth.signOut();
    }

    ngOnDestroy() {
        this.authStateSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.component.ts